export const SAVING_PAYMENT_NOTICE = 'SAVING_PAYMENT_NOTICE'
export const UPDATING_PAYMENT_NOTICE = 'UPDATING_PAYMENT_NOTICE'
